import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_ADMIN_STOREFRONT_SHORTCUTS_BAR = `${URL_APP_ADMIN}/storefront-shortcuts-bar`
// @hygen:inject scoped-urls

export type DashRouteSet = DashRouteType<'app-admin-storefront-shortcuts-bar'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-storefront-shortcuts-bar': URL_ADMIN_STOREFRONT_SHORTCUTS_BAR,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
